// extracted by mini-css-extract-plugin
module.exports = {"invitationProperty":"styles__invitationProperty___2NcOc","capitalize":"styles__capitalize___e0aqP","faIcon":"styles__faIcon___2w3V_"};